import React, { useEffect, useState } from "react";
import "./Banner.css";
import axios from "../axios";
import requests from "../requests";
function Banner() {
  const [movieBanner, setMovieBanner] = useState([]);

  useEffect(() => {
    async function fetchMovieBanner() {
      const request = await axios.get(requests.fetchNetflixORiginals);
      let randomBanner = Math.floor(
        Math.random() * request.data.results.length
      );
      setMovieBanner(request.data.results[randomBanner]);
    }
    fetchMovieBanner();
    // console.log(movieBanner);
  }, []);
  // function truncate(str,n){
  //     return str?.length > n ? str.substring(0, n-1) +'...' : str;
  // }
  return (
    <div
      className="banner"
      style={{
        backgroundImage: `url("https://image.tmdb.org/t/p/original${movieBanner?.backdrop_path}")`,
        backgroundSize: "cover",
        backgroundPosition: " center center",
      }}
    >
      <div className="banner_contents">
        <h1 className="banner_title">
          {movieBanner.title || movieBanner.name || movieBanner.original_title}
        </h1>
        <div className="banner_buttons">
          <button className="banner_button">play</button>
          <button className="banner_button">Mylist</button>
        </div>
        <h4 className="banner_discription">
          {movieBanner?.overview?.length > 150
            ? movieBanner?.overview?.substring(0, 150) + "..."
            : movieBanner?.overview}
          {/* {tr(movie?.overview,150)} */}
        </h4>
      </div>
      <div className="banner_fade"></div>
    </div>
  );
}

export default Banner;
